import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { startSession, endSessionBeacon, trackPageView } from '../utils/analytics';

const AnalyticsTracker = () => {
  const location = useLocation();
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    startSession();

    const handleUnload = () => endSessionBeacon();
    window.addEventListener('beforeunload', handleUnload);
    return () => window.removeEventListener('beforeunload', handleUnload);
  }, []);

  useEffect(() => {
    trackPageView(document.title, location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
};

export default AnalyticsTracker;